import React, { createContext, useState, useContext, useEffect } from 'react';

export const SearchContext = createContext(); // <-- экспорт по имени

export function SearchProvider({ children, initialRoadsData, userPosition }) {
    const [searchResults, setSearchResults] = useState([]);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [roadsData, setRoadsData] = useState(null);

    // Обновляем данные контекста, когда получаем их из props
    useEffect(() => {
        if (initialRoadsData) {
            setRoadsData(initialRoadsData);
        }
    }, [initialRoadsData]);


    return (
        <SearchContext.Provider
            value={{
                searchResults,
                setSearchResults,
                selectedMarker,
                setSelectedMarker,
                roadsData,
                setRoadsData,
                userPosition
            }}
        >
            {children}
        </SearchContext.Provider>
    );
}

export function useSearch() {
    return useContext(SearchContext);
}